<template>
  <div :class="{ 'border-t border-b border-gray-500 py-4': bordered }">
    <p
      v-for="(description, index) in formatDescription"
      :key="index"
      v-html="findUrls(description)"
    ></p>
  </div>
</template>

<script>
export default {
  name: "DoeParagraph",
  props: {
    description: {
      type: [Array, String],
      required: false
    },
    bordered: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    formatDescription() {
      if (!Array.isArray(this.description)) {
        return new Array(this.description);
      } else {
        return this.description;
      }
    }
  },
  methods: {
    findUrls(text) {
      return text.replace(
        /[[]{1}([^\]]+)[\]]{1}[(]{1}([^)"]+)("(.+)")?[)]{1}/g,
        '<a href="$2" target="_blank">$1<span class="sr-only">Opens external website</span></a>'
      );
    }
  }
};
</script>

<style lang="scss" scoped>
p {
  @apply font-sans font-light text-base text-black leading-loose;
}
p + p {
  @apply mt-3;
}
p /deep/ a {
  @apply inline-block relative underline;
}
p /deep/ a[href*="//"]:not([href*="localhost.com"]) {
  padding-right: 1.5rem;
  &:after {
    @apply absolute block;
    content: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 100 89'><path d='M100,4.16666667 L100,26.3861111 C100,30.1119792 95.4930556,31.9381944 92.8869792,29.3324653 L86.6878472,23.1329861 L44.4095486,65.4112847 C42.7822917,67.0385417 40.1442708,67.0385417 38.5170139,65.4112847 L34.5887153,61.4829861 C32.9614583,59.8557292 32.9614583,57.2175347 34.5887153,55.5904514 L76.8673611,13.3118056 L70.6689236,7.11302083 C68.0524306,4.49652778 69.9055556,0 73.6152778,0 L95.8333333,0 C98.1345486,0 100,1.86545139 100,4.16666667 Z M70.6647569,47.0128472 L67.8869792,49.790625 C67.1055707,50.5720468 66.6666073,51.6318913 66.6666667,52.7369792 L66.6666667,77.7777778 L11.1111111,77.7777778 L11.1111111,22.2222222 L56.9444444,22.2222222 C58.049457,22.2221592 59.1092025,21.783211 59.890625,21.0019097 L62.6684028,18.2241319 C65.2932292,15.5991319 63.4342014,11.1111111 59.7222222,11.1111111 L8.33333333,11.1111111 C3.73090278,11.1111111 0,14.8420139 0,19.4444444 L0,80.5555556 C0,85.1579861 3.73090278,88.8888889 8.33333333,88.8888889 L69.4444444,88.8888889 C74.046875,88.8888889 77.7777778,85.1579861 77.7777778,80.5555556 L77.7777778,49.9590278 C77.7777778,46.246875 73.2895833,44.3878472 70.6647569,47.0128472 Z' /></svg>");
    top: 0px;
    right: 0px;
    width: 1.25rem;
    height: 1.25rem;
  }
}
</style>
